// TODO: we're sharing credentials \o/
export const SECRET_KEY =
  '$2a$10$C3/5kVnWddDXzV9lVUASCOjrO48j1B.hOzwcW9hvaKHWtqOswWgDC'
export const COLLECTION_ID = '5cf3c85f3185c64c762b627c'
